module.exports = "https://web-assets-production.autolist.com/_next/static/images/suv-9b1985e3dd2628e6e7091793d479968a.jpg";